<template>
    <section class="content py-5">
        <div class="container mt-5">
            <h1 class="text-center mb-4">FAQs</h1>
            <div class="container mt-5">
                <b-accordion id="faq-accordion" class="accordion">
                <div v-for="(faq, index) in faqsData" :key="index">
                    <b-card no-body class="border">
                    <b-card-header class="p-2 cursor-pointer" v-b-toggle="'faq-' + index">
                        <div class="row">
                        <div class="col-6 d-flex align-items-center">
                            <span class="font-weight-bold font-14 ml-2">{{ faq.que }}</span>
                        </div>
                        <div class="col-6 d-flex align-items-center justify-content-end">
                            <i v-if="faq.open" class="fa fa-chevron-up open"></i>
                            <i v-else class="fa fa-chevron-down closed"></i>
                        </div>
                        </div>
                    </b-card-header>

                    <b-collapse :id="'faq-' + index" class="p-2 border border-top-0" v-model="faq.open">
                        <b-card-body>
                        <span v-html="faq.ans"></span>
                        </b-card-body>
                    </b-collapse>
                    </b-card>
                </div>
                </b-accordion>
            </div>
            
            <div class="text-center mt-4">
                <p>Contact us:</p>
                <p><strong>Email:</strong> <a href="mailto:support@angelcommunities.org">support@angelcommunities.org</a></p>
                <p><strong>WhatsApp:</strong> +44 7441 444005</p>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: "FAQs",
    data() {
        return {
            faqsData: [
                { 
                    "que": "How do I create an account on Angel Communities ticketing system?",
                    "ans": `To create an account, visit Angel Communities and click on "Register" button. Follow the on-screen instructions to complete the registration process.` 
                },
                { 
                    "que": "I forgot my password. How can I reset it?",
                    "ans": `If you forget your password, click on the "Forgot Password" link on the login page. You will receive instructions on your registered email to reset your password.` 
                },
                { 
                    "que": "How do I create an event on Angel Communities?",
                    "ans": `Create an account on Angel Communities. On your dashboard, completely set up your profile and organization. Click on Events and click on the Add Events to add an event` 
                },
                { 
                    "que": "Can I have access to an Attendee Report as an event organizer?",
                    "ans": `Yes, you can. To obtain this report, login to the dashboard, click on event and click on attendee report.` 
                },
                { 
                    "que": "Will I be able to tell the number of tickets sold as an event organizer?",
                    "ans": `Yes, you will be able to. This information will be available to you on your dashboard, under events> Ticket Purchase Report.` 
                },
                { 
                    "que": "What payment methods are accepted?",
                    "ans": `Angel Communities ticketing system typically accepts major credit cards and sometimes other payment methods like Mobile Money based on the individual/’s country. Check the event page or the payment section during checkout for specific details.` 
                },
                { 
                    "que": "Is there any agreement? ",
                    "ans": ` Yes, by signing up to Angel Communities, you agree to abide by our terms and conditions. These terms govern your use of our platform and services. If you have specific requests or need further clarification regarding our terms, please feel free to contact our support team at support@angelcommunities.org` 
                },
                { 
                    "que": " Are there any charges for using the Angel Communities platform?",
                    "ans": `Fees may not apply in every instance. For more details or specific inquiries regarding fees, please get in touch with us for further information. You can reach our support team at support@angelcommunities.org.` 
                },
                { 
                    "que": "I bought the wrong tickets. Can I get a refund or exchange?",
                    "ans": `Ticket refund and exchange policies vary by event. Contact the event organizer or check the event page for information on their refund/exchange policy. Angel Communities itself may not handle individual event transactions.` 
                },
                { 
                    "que": "How do I transfer tickets to someone else?",
                    "ans": `Log in to your account, go to the event page, and find the option to transfer tickets. Follow the prompts to enter the recipient's details, and they will receive an email with instructions on claiming the tickets.` 
                },
                { 
                    "que": "Can I view and print my purchased tickets?",
                    "ans": `Yes, after purchasing tickets, your purchased tickets will be sent to via the email you used in purchase. You can then print your tickets or download them for mobile entry.` 
                },
                { 
                    "que": "As an event organizer, how do I retrieve funds after my attendees purchase tickets?",
                    "ans": `You can access your funds once a fortnight. Kindly send a request email to support@angelcommunities.org` 
                },
                { 
                    "que": "Is there a mobile app for Angel Communities ticketing?",
                    "ans": `Angel Communities may have a mobile-friendly website, but for a dedicated app, check the App Store (iOS) or Google Play Store (Android) for any official Angel Communities app.` 
                },
                { 
                    "que": "I have a question about an event. Who do I contact?",
                    "ans": `Feel free to reach out to us either via WhatsApp or by sending an email to support@angelcommunities.org . We are here to assist you with any questions or concerns you may have, and we'll be more than happy to help` 
                }
            ]
        }
    }
}
</script>